import axios from "axios"

import { env } from "@/config/env"

export interface SendReviewRequest {
  user_id: string
  project_id: string
  review: string
  name?: string
  rating?: number
}

export interface SendReviewResponse {
  success: boolean
}

async function generateFeedbackHmac(body: object): Promise<string> {
  const encoder = new TextEncoder()
  const key = await crypto.subtle.importKey(
    "raw",
    encoder.encode(env.VITE_FEEDBACK_SECRET_KEY),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  )
  const signature = await crypto.subtle.sign(
    "HMAC",
    key,
    encoder.encode(JSON.stringify(body)),
  )
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
}

export async function sendReview(
  data: SendReviewRequest,
): Promise<SendReviewResponse> {
  const body = {
    id: crypto.randomUUID(),
    user_id: data.user_id,
    project_id: data.project_id,
    review: data.review,
    ...(data.name ? { name: data.name } : {}),
    ...(data.rating ? { rating: data.rating } : {}),
    timestamp: Math.floor(Date.now() / 1000),
  }

  const signature = await generateFeedbackHmac(body)

  const { data: response } = await axios.post<SendReviewResponse>(
    `${env.VITE_FEEDBACK_API_URL}/api/reviews`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        "x-signature": signature,
      },
    },
  )

  return response
}
